module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_tiempo_1993.b5ac76d0.jpg";